import { Component } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet } from '@angular/router';
import { version, date } from '../../package.json';
import { AuthService } from './shared/services/auth.service';
import { STAGE } from './shared/constants';
import { ModalService } from './shared/components/modals/modal.service';
import { ToastComponent } from './shared/components/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {
  stage = STAGE;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private router: Router,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.modalService.showSpinner('Cargando...');
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof NavigationEnd) {
        this.modalService.hideSpinner();
      }
    });
  }

  ngOnInit() {
    console.log(`RUM ${this.stage ? this.stage : ''} Ver: ${version} - ${date}`);
    let hasToken = this.authService.hasToken();
    let hasRefresh = this.authService.hasRefreshToken();
    let user = this.authService.getUserSesion();
    if (user && hasToken && hasRefresh) {
      const accessToken = this.authService.getAccessToken();
      const refreshToken = this.authService.getRefreshToken();
      this.authService.setSession(accessToken, refreshToken);
      this.authService.isLoggedIn.set(true);
    } else {
      this.authService.destroySession();
    }
  }

}